module.exports = __webpack_public_path__ + "static/media/logo-united-way.615d8f0b.png";